import { fadeInHeightExpandTransition as d } from "./ghl-ui.es1315.js";
import { c as e, cB as r, cM as t, cE as o, cNotM as n } from "./ghl-ui.es384.js";
const l = [e("&::before", "background-color: var(--n-item-color-hover);"), o("arrow", `
 color: var(--n-arrow-color-hover);
 `), o("icon", `
 color: var(--n-item-icon-color-hover);
 `), r("menu-item-content-header", `
 color: var(--n-item-text-color-hover);
 `, [e("a", `
 color: var(--n-item-text-color-hover);
 `), o("extra", `
 color: var(--n-item-text-color-hover);
 `)])], v = [o("icon", `
 color: var(--n-item-icon-color-hover-horizontal);
 `), r("menu-item-content-header", `
 color: var(--n-item-text-color-hover-horizontal);
 `, [e("a", `
 color: var(--n-item-text-color-hover-horizontal);
 `), o("extra", `
 color: var(--n-item-text-color-hover-horizontal);
 `)])], s = e([r("menu", `
 background-color: var(--n-color);
 color: var(--n-item-text-color);
 overflow: hidden;
 transition: background-color .3s var(--n-bezier);
 box-sizing: border-box;
 font-size: var(--n-font-size);
 padding-bottom: 6px;
 `, [t("horizontal", `
 max-width: 100%;
 width: 100%;
 display: flex;
 overflow: hidden;
 padding-bottom: 0;
 `, [r("submenu", "margin: 0;"), r("menu-item", "margin: 0;"), r("menu-item-content", `
 padding: 0 20px;
 border-bottom: 2px solid #0000;
 `, [e("&::before", "display: none;"), t("selected", "border-bottom: 2px solid var(--n-border-color-horizontal)")]), r("menu-item-content", [t("selected", [o("icon", "color: var(--n-item-icon-color-active-horizontal);"), r("menu-item-content-header", `
 color: var(--n-item-text-color-active-horizontal);
 `, [e("a", "color: var(--n-item-text-color-active-horizontal);"), o("extra", "color: var(--n-item-text-color-active-horizontal);")])]), t("child-active", `
 border-bottom: 2px solid var(--n-border-color-horizontal);
 `, [r("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-horizontal);
 `, [e("a", `
 color: var(--n-item-text-color-child-active-horizontal);
 `), o("extra", `
 color: var(--n-item-text-color-child-active-horizontal);
 `)]), o("icon", `
 color: var(--n-item-icon-color-child-active-horizontal);
 `)]), n("disabled", [n("selected, child-active", [e("&:focus-within", v)]), t("selected", [i(null, [o("icon", "color: var(--n-item-icon-color-active-hover-horizontal);"), r("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover-horizontal);
 `, [e("a", "color: var(--n-item-text-color-active-hover-horizontal);"), o("extra", "color: var(--n-item-text-color-active-hover-horizontal);")])])]), t("child-active", [i(null, [o("icon", "color: var(--n-item-icon-color-child-active-hover-horizontal);"), r("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover-horizontal);
 `, [e("a", "color: var(--n-item-text-color-child-active-hover-horizontal);"), o("extra", "color: var(--n-item-text-color-child-active-hover-horizontal);")])])]), i("border-bottom: 2px solid var(--n-border-color-horizontal);", v)]), r("menu-item-content-header", [e("a", "color: var(--n-item-text-color-horizontal);")])])]), n("responsive", [r("menu-item-content-header", `
 overflow: hidden;
 text-overflow: ellipsis;
 `)]), t("collapsed", [r("menu-item-content", [t("selected", [e("&::before", `
 background-color: var(--n-item-color-active-collapsed) !important;
 `)]), r("menu-item-content-header", "opacity: 0;"), o("arrow", "opacity: 0;"), o("icon", "color: var(--n-item-icon-color-collapsed);")])]), r("menu-item", `
 height: var(--n-item-height);
 margin-top: 6px;
 position: relative;
 `), r("menu-item-content", `
 box-sizing: border-box;
 line-height: 1.75;
 height: 100%;
 display: grid;
 grid-template-areas: "icon content arrow";
 grid-template-columns: auto 1fr auto;
 align-items: center;
 cursor: pointer;
 position: relative;
 padding-right: 18px;
 transition:
 background-color .3s var(--n-bezier),
 padding-left .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [e("> *", "z-index: 1;"), e("&::before", `
 z-index: auto;
 content: "";
 background-color: #0000;
 position: absolute;
 left: 8px;
 right: 8px;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), t("disabled", `
 opacity: .45;
 cursor: not-allowed;
 `), t("collapsed", [o("arrow", "transform: rotate(0);")]), t("selected", [e("&::before", "background-color: var(--n-item-color-active);"), o("arrow", "color: var(--n-arrow-color-active);"), o("icon", "color: var(--n-item-icon-color-active);"), r("menu-item-content-header", `
 color: var(--n-item-text-color-active);
 `, [e("a", "color: var(--n-item-text-color-active);"), o("extra", "color: var(--n-item-text-color-active);")])]), t("child-active", [r("menu-item-content-header", `
 color: var(--n-item-text-color-child-active);
 `, [e("a", `
 color: var(--n-item-text-color-child-active);
 `), o("extra", `
 color: var(--n-item-text-color-child-active);
 `)]), o("arrow", `
 color: var(--n-arrow-color-child-active);
 `), o("icon", `
 color: var(--n-item-icon-color-child-active);
 `)]), n("disabled", [n("selected, child-active", [e("&:focus-within", l)]), t("selected", [i(null, [o("arrow", "color: var(--n-arrow-color-active-hover);"), o("icon", "color: var(--n-item-icon-color-active-hover);"), r("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover);
 `, [e("a", "color: var(--n-item-text-color-active-hover);"), o("extra", "color: var(--n-item-text-color-active-hover);")])])]), t("child-active", [i(null, [o("arrow", "color: var(--n-arrow-color-child-active-hover);"), o("icon", "color: var(--n-item-icon-color-child-active-hover);"), r("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover);
 `, [e("a", "color: var(--n-item-text-color-child-active-hover);"), o("extra", "color: var(--n-item-text-color-child-active-hover);")])])]), t("selected", [i(null, [e("&::before", "background-color: var(--n-item-color-active-hover);")])]), i(null, l)]), o("icon", `
 grid-area: icon;
 color: var(--n-item-icon-color);
 transition:
 color .3s var(--n-bezier),
 font-size .3s var(--n-bezier),
 margin-right .3s var(--n-bezier);
 box-sizing: content-box;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 `), o("arrow", `
 grid-area: arrow;
 font-size: 16px;
 color: var(--n-arrow-color);
 transform: rotate(180deg);
 opacity: 1;
 transition:
 color .3s var(--n-bezier),
 transform 0.2s var(--n-bezier),
 opacity 0.2s var(--n-bezier);
 `), r("menu-item-content-header", `
 grid-area: content;
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 opacity: 1;
 white-space: nowrap;
 color: var(--n-item-text-color);
 `, [e("a", `
 outline: none;
 text-decoration: none;
 transition: color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 `, [e("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), o("extra", `
 font-size: .93em;
 color: var(--n-group-text-color);
 transition: color .3s var(--n-bezier);
 `)])]), r("submenu", `
 cursor: pointer;
 position: relative;
 margin-top: 6px;
 `, [r("menu-item-content", `
 height: var(--n-item-height);
 `), r("submenu-children", `
 overflow: hidden;
 padding: 0;
 `, [d({
  duration: ".2s"
})])]), r("menu-item-group", [r("menu-item-group-title", `
 margin-top: 6px;
 color: var(--n-group-text-color);
 cursor: default;
 font-size: .93em;
 height: 36px;
 display: flex;
 align-items: center;
 transition:
 padding-left .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)])]), r("menu-tooltip", [e("a", `
 color: inherit;
 text-decoration: none;
 `)]), r("menu-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 6px 18px;
 `)]);
function i(c, a) {
  return [t("hover", c, a), e("&:hover", c, a)];
}
export {
  s as default
};
